import script from "./ReferralPortalSignupCustomFields.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferralPortalSignupCustomFields.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__